export enum OnboardingContentType {
  Multiply = 'multiply',
  LendToken = 'lendToken',
  LendNft = 'lendNft',
  BorrowToken = 'borrowToken',
}
